import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { LinkTarget } from 'core/enums';
import { formatDate } from 'core/utils';
import { QuoteIdCell } from 'quotes/elements';

export const getColumnDef = (): ColDef[] => [
  {
    colId: 'vendorCompanyName',
    headerName: t('headerVendor'),
    field: 'vendorCompanyName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'customerProjectName',
    headerName: t('headerProject'),
    field: 'customerProjectName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'jobName',
    headerName: t('headerJob'),
    field: 'jobName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'quoteId',
    headerName: t('headerQuoteId'),
    field: 'quoteId',
    filter: 'agTextColumnFilter',
    cellRenderer: QuoteIdCell,
    cellRendererParams: {
      target: LinkTarget.BLANK,
    },
  },
  {
    colId: 'customId',
    headerName: t('headerQuoteCustomerId'),
    field: 'customId',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'externalNumber',
    headerName: t('headerVendorQuoteNumber'),
    field: 'externalNumber',
    filter: 'agTextColumnFilter',
  },

  {
    colId: 'startDate',
    headerName: t('headerValidSince'),
    field: 'startDate',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'endDate',
    headerName: t('headerValidUntil'),
    field: 'endDate',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'customerName',
    headerName: t('headerQuotedTo'),
    field: 'customerName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'vendorName',
    headerName: t('headerQuotedBy'),
    field: 'vendorName',
    filter: 'agTextColumnFilter',
  },
];
